export enum TestimonialVariants {
  Base = 'Base',
  Cards = 'Cards',
}
